import { defineComponent as w, useCssVars as b, unref as e, openBlock as l, createElementBlock as h, normalizeClass as u, renderSlot as $, onMounted as T, createElementVNode as s, createBlock as _, withCtx as g, createVNode as n, ref as z, createCommentVNode as C, toDisplayString as y, Teleport as A, Transition as B, normalizeStyle as D } from "vue";
import { s as V, a as R, D as M, L as N, I as L, _ as I, p as O, R as P, N as U } from "../review.es.js";
import { R as E, M as S, u as j, a as W, P as q, V as F } from "./useTailwindTheme.D1_4gifO.js";
const G = ["disabled"], H = /* @__PURE__ */ w({
  __name: "Button",
  props: {
    appearance: { default: "outline" },
    disabled: { type: Boolean },
    colorScheme: {}
  },
  setup(r) {
    b((a) => ({
      "69df0f8b": a.$props.colorScheme.main,
      "7b1459bc": a.$props.colorScheme.main || e(o).actionColor.base,
      "5b5c6226": a.$props.colorScheme.text || e(o).actionColor.contrasted,
      49634480: a.$props.colorScheme.over || e(o).actionColor.over,
      "69e24eff": a.$props.colorScheme.text
    }));
    const t = r, o = R();
    return (a, i) => (l(), h("button", {
      class: u([
        "btn",
        `btn--${t.appearance}`
      ]),
      disabled: t.disabled
    }, [
      $(a.$slots, "default", {}, void 0, !0)
    ], 10, G));
  }
}), J = /* @__PURE__ */ V(H, [["__scopeId", "data-v-eba72d72"]]), K = { class: "collapse__inner" }, Q = /* @__PURE__ */ w({
  __name: "Collapse",
  props: {
    modelValue: { type: Boolean, default: !1 },
    animationDuration: { default: "0.5s" },
    direction: { default: "vertical" },
    autoOpen: { type: Boolean, default: !1 }
  },
  emits: ["update:modelValue"],
  setup(r, { emit: t }) {
    b((i) => ({
      "2a849078": o.animationDuration
    }));
    const o = r, a = t;
    return T(() => {
      o.autoOpen && M(() => {
        a("update:modelValue", !0);
      }, 0);
    }), (i, f) => (l(), h("div", {
      class: u([
        "collapse__main",
        o.direction === "vertical" ? "collapse__main--vertical" : "collapse__main--horizontal",
        { "collapse__main--open": o.modelValue }
      ])
    }, [
      s("div", K, [
        $(i.$slots, "default", {}, void 0, !0)
      ])
    ], 2));
  }
}), X = /* @__PURE__ */ V(Q, [["__scopeId", "data-v-0e2dfc19"]]), Y = { class: "reviews-header order-first" }, Z = /* @__PURE__ */ w({
  __name: "ReviewsModal",
  props: {
    config: {}
  },
  emits: [
    "close"
  ],
  setup(r, { emit: t }) {
    b((m) => ({
      "5f2c277b": e(i).backgroundColor.washed
    }));
    const o = r, a = t, i = R(), f = j();
    function c() {
      a("close");
    }
    return (m, x) => (l(), _(e(N), {
      "show-close": !1,
      "z-index": m.$props.config.calculate.tooltip.zIndex,
      class: u([
        "w-full sm:w-3/4 md:w-4/6 xl:w-1/2 max-w-[640px] max-h-[80vh] min-h-[26rem] flex flex-col root",
        { rtl: o.config.isRightAlign }
      ]),
      onClose: c
    }, {
      default: g(() => [
        n(E, {
          reviews: o.config.payload.reviews,
          "review-languages": o.config.payload.reviewLanguages
        }, null, 8, ["reviews", "review-languages"]),
        s("div", Y, [
          n(S, {
            data: o.config.payload.reviewAverages,
            colors: {
              darkText: e(f).colors.grey[900],
              lightText: e(f).colors.grey[500]
            },
            "text-style": {
              score: {
                size: "16px",
                weight: "400"
              },
              average: {
                size: "32px",
                weight: "400"
              },
              note: {
                size: "14px",
                weight: "600"
              },
              based: {
                size: "12px",
                weight: "400"
              }
            },
            tooltip: {
              ...o.config.calculate.tooltip,
              placement: "top"
            },
            orientation: "horizontal",
            class: "flex-1"
          }, null, 8, ["data", "colors", "tooltip"]),
          n(e(L), {
            type: "close",
            "over-color": e(i).backgroundColor.base,
            onActionClick: c,
            "data-testid": "close-modal"
          }, null, 8, ["over-color"])
        ])
      ]),
      _: 1
    }, 8, ["z-index", "class"]));
  }
}), ee = /* @__PURE__ */ I(Z, [["__scopeId", "data-v-852e39e8"]]), oe = { class: "root__inner" }, te = { class: "module providerRating" }, ae = { class: "providerRating__score" }, ie = { class: "providerRating__max" }, se = {
  key: 1,
  class: "module cta flex justify-end shrink-0"
}, ne = { class: "text-sm" }, le = /* @__PURE__ */ w({
  __name: "InlineReview",
  props: {
    config: {}
  },
  setup(r) {
    var x, k;
    b((v) => ({
      ebda1c98: e(m),
      "5b04a296": e(o).borderRadius,
      a28b9bbe: e(o).backgroundColor.base,
      "27059ce0": e(o).borderColor,
      "22a2531e": e(o).backgroundColor.contrasted
    }));
    const t = r, o = R(), { t: a } = O(), i = z(!1), f = P(t.config.isRightAlign), c = z(!1), m = U({
      width: (x = t.config.deviceStyleConfig.extra) == null ? void 0 : x.width,
      widthUnit: (k = t.config.deviceStyleConfig.extra) == null ? void 0 : k.widthUnit
    });
    return (v, d) => (l(), _(e(X), {
      modelValue: i.value,
      "onUpdate:modelValue": d[2] || (d[2] = (p) => i.value = p),
      "auto-open": "",
      role: "region",
      "aria-label": e(a)("Review Summary"),
      class: "root"
    }, {
      default: g(() => [
        s("div", oe, [
          s("div", {
            class: u([
              "root widget widget--inline",
              { "widget--bordered": e(o).border }
            ]),
            "data-testid": "widget"
          }, [
            s("div", {
              class: u([
                "module mainRating separator",
                t.config.isRightAlign ? "separator--before" : "separator--after"
              ])
            }, [
              n(S, {
                data: v.config.payload.reviewAverages,
                colors: {
                  darkText: e(o).backgroundColor.contrasted,
                  lightText: e(o).backgroundColor.contrasted
                },
                orientation: "horizontal",
                "show-info-btn": "",
                "text-style": {
                  score: {
                    size: "16px",
                    weight: "400"
                  },
                  average: {
                    size: "32px",
                    weight: "400"
                  },
                  note: {
                    size: "14px",
                    weight: "600"
                  },
                  based: {
                    size: "12px",
                    weight: "400"
                  }
                },
                tooltip: {
                  ...t.config.calculate.tooltip,
                  placement: "top"
                },
                class: "mainRating__content"
              }, {
                providersInfo: g(() => [
                  n(W, {
                    data: t.config.calculate.providers,
                    direction: e(f),
                    "text-style": {
                      score: {
                        weight: "400"
                      }
                    }
                  }, null, 8, ["data", "direction"])
                ]),
                _: 1
              }, 8, ["data", "colors", "tooltip"])
            ], 2),
            t.config.calculate.rankingConfig.visible ? (l(), h("div", {
              key: 0,
              class: u([
                "module ranking separator",
                t.config.isRightAlign ? "separator--before" : "separator--after"
              ])
            }, [
              n(q, {
                config: t.config.calculate.rankingConfig,
                "hightlight-color": e(o).actionContrastColor.base,
                inline: "",
                class: "ranking__content"
              }, null, 8, ["config", "hightlight-color"])
            ], 2)) : C("", !0),
            s("div", te, [
              n(e(F), {
                items: t.config.calculate.providers.slice(0, 5),
                direction: "row"
              }, {
                value: g(({ item: p }) => [
                  s("span", ae, y(p.value.score), 1),
                  s("span", ie, " /" + y(p.value.max), 1)
                ]),
                _: 1
              }, 8, ["items"])
            ]),
            t.config.showReviews ? (l(), h("div", se, [
              n(e(J), {
                onClick: d[0] || (d[0] = (p) => c.value = !0),
                "color-scheme": {
                  main: e(o).actionContrastColor.base,
                  text: e(o).actionContrastColor.base
                },
                class: "trigger text-sm",
                "data-testid": "read-reviews"
              }, {
                default: g(() => [
                  s("span", ne, y(e(a)("Read Reviews")), 1)
                ]),
                _: 1
              }, 8, ["color-scheme"])
            ])) : C("", !0),
            (l(), _(A, {
              to: t.config.modalRootContainer ?? "body"
            }, [
              n(B, { name: "fade" }, {
                default: g(() => [
                  c.value ? (l(), _(ee, {
                    key: 0,
                    config: v.config,
                    onClose: d[1] || (d[1] = (p) => c.value = !1),
                    style: D({ "z-index": v.$props.config.zIndex })
                  }, null, 8, ["config", "style"])) : C("", !0)
                ]),
                _: 1
              })
            ], 8, ["to"]))
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "aria-label"]));
  }
}), pe = /* @__PURE__ */ I(le, [["__scopeId", "data-v-fbdbadfe"]]);
export {
  pe as default
};
//# sourceMappingURL=InlineReview.gnElhM_m.js.map
